<script>
  // View switcher for an entity list (table / grid / board). Shows only the views the
  // entity supports and persists the choice to localStorage per entity so it sticks
  // across visits. Two-way binds `viewMode`.
  //
  //   <DisplayOptions entity="media" bind:viewMode />
  import Icon from '../ui/icon.svelte'
  import { entityFor, viewsFor } from '../../lib/entities/index.js'

  let { entity, viewMode = $bindable(null) } = $props()

  const config = $derived(entityFor(entity))
  const views = $derived(viewsFor(entity))
  const storageKey = $derived(`admin_view:${entity}`)

  const ICONS = { table: 'list', grid: 'dashboard', board: 'stack' }
  const LABELS = { table: 'Table', grid: 'Grid', board: 'Board' }

  // Initialize from localStorage → entity default, once, if not already set.
  $effect(() => {
    if (viewMode) return
    let stored = null
    try {
      stored = window.localStorage.getItem(storageKey)
    } catch {
      stored = null
    }
    viewMode = views.includes(stored) ? stored : config.defaultView ?? 'table'
  })

  const pick = (mode) => {
    viewMode = mode
    try {
      window.localStorage.setItem(storageKey, mode)
    } catch {
      /* ignore */
    }
  }
</script>

{#if views.length > 1}
  <div class="join" role="group" aria-label="View mode">
    {#each views as mode (mode)}
      <button
        type="button"
        class="btn btn-sm join-item"
        class:btn-active={viewMode === mode}
        aria-pressed={viewMode === mode}
        title={LABELS[mode]}
        onclick={() => pick(mode)}
      >
        <Icon name={ICONS[mode] ?? 'list'} size="sm" />
      </button>
    {/each}
  </div>
{/if}
